import { Step } from 'react-joyride';

export const sellerUpgradeSteps: Step[] = [
  {
    target: 'body',
    content: 'Welcome! Let us show you everything included in your Shark Plan subscription.',
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '[data-tour="feature-list"]',
    content: 'Unlock unlimited listings, advanced buyer search, direct contact info, real-time notifications, buyer list management, analytics, and priority support.',
    disableBeacon: true,
  },
  {
    target: '[data-tour="roi-callout"]',
    content: 'Just one additional deal pays for your entire subscription. Plus, cancel anytime with no contracts.',
    disableBeacon: true,
  },
  {
    target: '[data-tour="plan-selector"]',
    content: 'Choose your plan: Monthly for flexibility, or Annual to save 17% on your subscription.',
    disableBeacon: true,
  },
  {
    target: '[data-tour="promo-code"]',
    content: 'Have a promo code? Enter it here to apply your discount before completing payment.',
    disableBeacon: true,
  },
  {
    target: '[data-tour="payment-form"]',
    content: 'Enter your payment details to complete your upgrade. Secure processing powered by Stripe.',
    disableBeacon: true,
  },
];
